import React from "react";
import { IconClose16 } from "@warp-ds/icons/react/close-16";
import { CloseButtonBody } from "../styles";

type Props = {
  close: () => void;
};

export const CloseButton = ({ close }: Props) => (
  <CloseButtonBody onClick={close}>
    <IconClose16 />
  </CloseButtonBody>
);
